import { StyleSheet } from 'react-native';
import styled, { css } from 'styled-components/native';

import {
  brightGrey,
  neutralDark,
  warrior,
  white,
} from '../../../constants/color';
import Image from '../../../elements/Image';
import LinearGradient from '../../../elements/LinearGradient';
import Touchable from '../../../elements/Touchable';
import { LIST_GAP } from '../styles';

export const ITEM_WIDTH = 100;
export const ITEM_MARGIN = 5;
export const LIST_CONTAINER_VERTICAL_PADDING = 8;
export const ONBOARDING_IMAGE_WIDTH = 90;

export const ONBOARDING_IMAGE_HEIGHT = ITEM_WIDTH - ITEM_MARGIN * 2;
const TITLE_LINE_HEIGHT = 26;
const LIST_MARGIN_BOTTOM = 20;

export const ONBOARDING_LIST_HEIGHT =
  ONBOARDING_IMAGE_HEIGHT +
  LIST_CONTAINER_VERTICAL_PADDING * 2 +
  LIST_MARGIN_BOTTOM;

const getListContainerStyle = ({
  isNewFetching,
}: {
  isNewFetching: boolean;
}) => {
  if (isNewFetching) {
    return css`
      margin: 0px 0px 0px 15px;
      padding: 0;
      background-color: transparent;
    `;
  }

  return css`
    margin: 0px 15px;
    padding: ${LIST_CONTAINER_VERTICAL_PADDING}px 5px;
    background-color: ${white};
  `;
};

interface LoadingProps {
  isNewFetching: boolean;
}

export const S = {
  TitleSection: styled(LinearGradient)<LoadingProps & { width: number }>`
    margin: 0px ${LIST_GAP}px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    padding: ${({ isNewFetching }) => (isNewFetching ? '10px 0px' : '10px')};
    flex-direction: row;
    justify-content: space-between;
    width: ${({ width }) => width - LIST_GAP * 2}px;
    flex: 1;
    flex-basis: auto;
  `,
  TitleText: styled.Text<LoadingProps>`
    color: ${({ isNewFetching }) => (isNewFetching ? warrior : white)};
    font-size: 18px;
    font-weight: 700;
    line-height: ${TITLE_LINE_HEIGHT}px;
  `,
  WatchMore: styled(Touchable)`
    flex-direction: row;
    align-items: center;
  `,
  WatchMoreText: styled.Text<LoadingProps>`
    color: ${({ isNewFetching }) => (isNewFetching ? neutralDark : white)};
  `,
  ListContainer: styled.View<{
    isNewFetching: boolean;
  }>`
    ${getListContainerStyle};
    /* 
      web 在外層的 View 需要給 flex: 1 ，FlatList 才能滾動： 
      https://github.com/necolas/react-native-web/issues/1436#issuecomment-612845122
    */
    flex: 1;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    flex-direction: row;
    margin-bottom: 18px;
  `,
  ListFooter: styled(Touchable)`
    margin: auto 30px;
  `,
  ListFooterTextContainer: styled.View`
    justify-content: center;
    align-items: center;
  `,
  ListFooterText: styled.Text`
    font-size: 15px;
    line-height: 21px;
    color: ${warrior};
    margin-top: 8px;
  `,
  ImageContainer: styled(Touchable)`
    margin: auto 5px auto 0;
    width: ${ONBOARDING_IMAGE_WIDTH}px;
    height: ${ONBOARDING_IMAGE_HEIGHT}px;
  `,
  Image: styled(Image)`
    border-radius: 6px;
    width: 100%;
    height: 100%;
  `,
};

const styles = StyleSheet.create({
  listItemFontStyle: {
    fontSize: 13,
    lineHeight: 18,
  },
  contentWrapperStyle: {
    minHeight: 70,
  },
  listItemPriceStyle: {
    fontSize: 13,
    lineHeight: 18,
  },
  listItemWrapperStyle: {
    marginTop: 'auto',
    marginBottom: 'auto',
    borderColor: brightGrey,
    borderWidth: 1,
    borderStyle: 'solid',
    borderRadius: 5,
    overflow: 'hidden',
  },
  imagePlaceholderWrapper: {
    position: 'absolute',
    top: 0,
    left: 0,
    marginRight: 10,
    borderRadius: 6,
  },
});

export default styles;
